import { render, staticRenderFns } from "./DrawCanvas.vue?vue&type=template&id=298b3b18&"
import script from "./DrawCanvas.vue?vue&type=script&lang=js&"
export * from "./DrawCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports